<template>
  <div class="graph" ref="target"></div>
</template>

<script>
import { PieChart, Tool } from "@/plugins/echarts_bank/index";
import { pieColors } from "@/utils/public";
export default {
  props: {
    dataList: {
      type: Array,
      required: true
    },
    commonFont: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      graph: null,
      colors: pieColors
    };
  },
  mounted() {
    const basicSize = this.commonFont;
    this.graph = new PieChart({
      ele: this.$refs.target,
      fontSize: basicSize,
      palletColors: this.colors,
      legend: {
        show: true,
        top: "auto",
        bottom: basicSize,
        icon: "rect",
        itemWidth: (basicSize * 4) / 3
      },
      tooltip: {
        show: true,
        formatter: function (res) {
          var marker;
          if (Tool.isType(res.color) === "Object") {
            marker =
              '<span style="background:linear-gradient(to bottom, ' +
              res.color.colorStops[0].color +
              ", " +
              res.color.colorStops[1].color +
              ');"></span>';
          } else {
            marker = res.marker;
          }
          return (
            '<div style="padding:0 ' +
            basicSize * 0.5 +
            "px;font-size:" +
            basicSize +
            'px;"><p>' +
            res.name +
            "</p><p>" +
            marker +
            res.seriesName +
            "：" +
            res.percent +
            "%</p></div>"
          );
        }
      },
      series: {
        name: "占比",
        center: ["50%", "45%"],
        radius: ["40%", "75%"],
        startAngle: 0,
        label: {
          position: "inside",
          formatter: "{d}%",
          fontSize: (basicSize * 4) / 3
        },
        emphasis: {
          focus: "self"
        }
      }
    });
    this.create();
  },
  methods: {
    processData(data, key, value, colors) {
      return data.map((item, i) => {
        let // data->itemStyle颜色
          itemStyle = {
            color: colors[i]
          };
        return {
          itemStyle,
          name: item[key],
          value: Number.parseFloat(item[value])
        };
      });
    },
    create() {
      const data = this.processData(
        this.dataList,
        "name",
        "value",
        this.colors
      );
      this.graph.setData(data).draw();
    }
  }
};
</script>

<style></style>
